"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddCircleIcon = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const IconContainer_1 = __importDefault(require("./IconContainer"));
const AddCircleIcon = (_a) => {
    var { className, rotate, size, title } = _a, props = __rest(_a, ["className", "rotate", "size", "title"]);
    return (react_1.default.createElement(IconContainer_1.default, Object.assign({ className: (0, classnames_1.default)("gerudo-icon-add-circle", size, className) }, props),
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", version: "1.0", viewBox: "0 0 24 24", fill: "currentColor", style: { transform: `rotate(${rotate}deg)` }, role: "img", "aria-label": title },
            react_1.default.createElement("title", null, title),
            react_1.default.createElement("circle", { vectorEffect: "non-scaling-stroke", shapeRendering: "geometricPrecision", cx: "12", cy: "12", r: "11.5", fill: "currentColor", role: "presentation" }),
            react_1.default.createElement("path", { vectorEffect: "non-scaling-stroke", shapeRendering: "geometricPrecision", d: "M12.5,1.5a11,11,0,1,1-11,11,11.013,11.013,0,0,1,11-11m0-1a12,12,0,1,0,12,12,12,12,0,0,0-12-12Z", transform: "translate(-0.5 -0.5)", fill: "currentColor", role: "presentation" }),
            react_1.default.createElement("line", { vectorEffect: "non-scaling-stroke", shapeRendering: "geometricPrecision", strokeMiterlimit: "10", x1: "17.038", y1: "6.962", x2: "6.962", y2: "17.038", fill: "none", stroke: "#fff", strokeWidth: "0.0833em", role: "presentation" }),
            react_1.default.createElement("line", { vectorEffect: "non-scaling-stroke", shapeRendering: "geometricPrecision", strokeMiterlimit: "10", x1: "6.962", y1: "6.962", x2: "17.038", y2: "17.038", fill: "none", stroke: "#fff", strokeWidth: "0.0833em", role: "presentation" }))));
};
exports.AddCircleIcon = AddCircleIcon;
AddCircleIcon.defaultProps = {
    rotate: 45,
    title: "Add",
};
exports.default = AddCircleIcon;
//# sourceMappingURL=AddCircle.js.map